import axios from './configAxiosOrganizations';

export const getAllOrganizations = async (url) => {
	return await axios.get(`/list/${url}`);
};
